var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"spinner-border",class:[
	_vm.small ? 'spinner-border-sm' : '',
	_vm.theme ? 'text-'+_vm.theme : ''
],attrs:{"role":"status"}},[_c('span',{staticClass:"sr-only d-none"},[_vm._v("Chargement ...")])])}
var staticRenderFns = []

export { render, staticRenderFns }